import CancellationReason from './CancellationReason'

class CancellationReasons extends Array {
    constructor(reasons = []) {
        super()

        if (!Array.isArray(reasons)) {
            return
        }

        reasons.forEach(({ id, value }) => this.push(id, value))
    }

    push(id, value) {
        return super.push(new CancellationReason(id, value))
    }
}

export default CancellationReasons
